module.exports = __webpack_public_path__ + "img/pt.a2ebca1e.png";